'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var toonUnified = function toonUnified() {
  return import('@/page/toon-auth');
};
var bjouUnified = function bjouUnified() {
  return import('@/page/bjou-auth');
};
exports.default = [{
  path: '/toonUnified',
  name: 'toonUnified',
  component: toonUnified,
  meta: {
    title: '北京市统一身份认证结果'
  }
}, {
  path: '/bjouUnified',
  name: 'bjouUnified',
  component: bjouUnified,
  meta: {
    title: '北开统一认证结果'
  }
}];